import styled, { themeGet, device } from "@theme/utils";
export const PartnerWrap = styled.div`
    padding: 60px 0;
    border-bottom: 1px solid #ededed !important;
`;
export const TrustedPartnersBox = styled.div`
    border-radius: 15px;
`;
export const SectionTitleThree = styled.div`
    margin-bottom: 20px;
    text-align: left;
`;
export const Title = styled.h6``;
